import { JSX } from 'react'
import { translations } from '../../../../configs/translations'
import { useStore } from '../../../../store/store'
import './DriftEventAnnounce.css'
import { EventAnnounce } from './DriftEventAnnounce.types'

export interface DriftEventAnnounceProps {
	data: EventAnnounce
}

export const DriftEventAnnounce = ({ data }: DriftEventAnnounceProps) => {
	const language = useStore(state => state.language) as keyof typeof translations
	const t = translations[language]

	const getTitle = (): JSX.Element => {
		if (data.event) {
			return <>{t.event} <span className='drift-event-announce-span'>{data.event.eventName}</span> {t.starting}</>
		} else if (data.other) {
			return <>{t[data.other.title as keyof typeof t]}</>
		}

		return <></>
	}

	const getText = (): JSX.Element => {
		if (data.event) {
			return <>{t[data.event.instruction as keyof typeof t]}</>
		} else if (data.other) {
			return <>{t[data.other.text as keyof typeof t]}</>
		}

		return <></>
	}

	return (
		<div className='drift-event-announce-container drift-event-announce-lifecycle'>
			<h1 className='drift-event-announce-title drift-event-announce-title-lifecycle'>
				{getTitle()}
			</h1>

			<p className='drift-event-announce-text drift-event-announce-text-lifecycle'>{getText()}</p>
		</div>
	)
}